import { render, staticRenderFns } from "./IconTextTile.vue?vue&type=template&id=6324b8e8&"
import script from "./IconTextTile.vue?vue&type=script&lang=js&"
export * from "./IconTextTile.vue?vue&type=script&lang=js&"
import style0 from "./IconTextTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports